import { combineReducers } from 'redux';
import { reservation } from '@breezeway/brzw-react-core';

export default combineReducers({
  flyoutReservation: reservation.reducers.flyoutReservation,
  flyoutReservationTasks: reservation.reducers.flyoutReservationTasks,
  reservation: reservation.reducers.reservation,
  reservationHistory: reservation.reducers.reservationHistory,
  reservationTasks: reservation.reducers.reservationTasks,
  reservationList: reservation.reducers.reservationList,
  reservationListSettings: reservation.reducers.reservationListSettings,
});
